
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

import enUK from "@/locales/project/en-UK.json";

import MutateEntity from "@/components/CRUXEntity/MutateEntity.vue";

import {
  ProjectResourcesCategory,
  ProjectResourcesType,
} from "@/helpers/project/typesDefinition";
import { required } from "@vuelidate/validators";
import { CREATE_PROJECT_RESOURCE } from "@/graphql/project/mutations";
import { GET_PROJECT_RESOURCES } from "@/graphql/project/queries";

type MessageSchema = typeof enUK;

export default defineComponent({
  setup(props, { emit }) {
    const { t } = useI18n<[MessageSchema], "en-UK">({
      useScope: "global",
      inheritLocale: true,
      messages: {
        "en-UK": enUK,
      },
    });

    const entityProps = {
      resourceLink: undefined,
      resourceType: ProjectResourcesType.URL,
      resourceCategory: ProjectResourcesCategory.ANALYSIS,
      label: undefined,
      tooltip: undefined,
    };

    const unmutableEntityProps = {
      projectId: props.projectId,
    };

    const validationRules = computed(() => ({
      resourceLink: { required },
      resourceType: { required },
      resourceCategory: { required },
      label: {},
      tooltip: {},
    }));

    const messages = {
      title: t("titles.resource.add"),
      formButtonLabel: t("buttons.resource.add"),
      error: t("errors.addResource"),
      success: t("success.addResource"),
    };

    const resourceTypeOptions = Object.values(ProjectResourcesType).map(
      (value) => ({
        id: value,
        name: t(`resourceTypes.${value}`),
      }),
    );

    const resourceCategoryOptions = Object.values(ProjectResourcesCategory).map(
      (value) => ({
        id: value,
        name: t(`resourceCategories.${value}`),
      }),
    );

    const closeModal = () => emit("close");

    const refetchQueries = [
      {
        query: GET_PROJECT_RESOURCES,
        variables: {
          projectId: props.projectId,
        },
      },
    ];

    return {
      t,
      enUK,
      ProjectResourcesType,
      entityProps,
      unmutableEntityProps,
      validationRules,
      messages,
      resourceTypeOptions,
      resourceCategoryOptions,
      closeModal,
      CREATE_PROJECT_RESOURCE,
      refetchQueries,
    };
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  emits: ["close"],
  components: {
    MutateEntity,
  },
});
